import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from 'src/app/services/settings.service';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LookupsService } from 'src/app/services/lookups/lookups.service';
import { ResponseResult } from 'src/app/models-classes/common.model';
import { environment } from 'src/environments/environment';
import { CustomValidators } from 'src/app/shared/validators/custom-validators';
declare var $: any;
declare var google: any;

@Component({
  selector: 'app-multiple-order',
  templateUrl: './multiple-order.component.html',
  styleUrls: ['./multiple-order.component.css']
})
export class MultipleOrderComponent implements OnInit {
  batchOrderForm: FormGroup;
  orderCount: number = 2; // Default number of orders
  serviceType: 'send' | 'receive' = 'send';
  isSubmitting = false;
  current_lang: string;
  address: any;
  isMapVisible = false;
  currentLocationTarget: 'sender' | 'receiver' = 'sender';
  currentOrderIndex: number = 0;
  paymentNumber: number = 0;
  paymentMethodText: string = 'Your payment method is Cach';
  isApple: boolean = false;
  selectedImages: { [key: number]: string[] } = {};
  vehicleSizes: any[] = [];

  paymentMethodIcons = {
    Cach: {
      iconClass: '/assets/img/cards/cash.png',
      numericValue: 0,
      text: 'Cach',
    },
    // POS: {
    //   iconClass: '/assets/img/cards/pos.png',
    //   numericValue: 1,
    //   text: 'POS',
    // },
    // ApplePay: {
    //   iconClass: '/assets/img/cards/apple-pay.png',
    //   numericValue: 2,
    //   text: 'Apple',
    // },
    Knet: {
      iconClass: '/assets/img/cards/knet.png',
      numericValue: 3,
      text: 'Knet',
    },
    Card: {
      iconClass: '/assets/img/cards/credit-card.png',
      numericValue: 4,
      text: 'Card',
    },
    WalletPay: {
      iconClass: '/assets/img/cards/wallet.png',
      numericValue: 5,
      text: 'Wallet',
    },
  };

  @ViewChild('senderMapContainer') senderMapContainer: ElementRef;
  @ViewChild('receiverMapContainer') receiverMapContainer: ElementRef;
  @ViewChild('senderSearchInput') senderSearchInput: ElementRef;
  @ViewChild('receiverSearchInput') receiverSearchInput: ElementRef;
  @ViewChild('mapContainer') mapContainer: ElementRef;
  @ViewChild('searchInput') searchInput: ElementRef;

  map: any;
  marker: any;
  geocoder: any;
  searchBox: any;

  // Store coordinates
  senderCoordinates: { lat: number; lng: number } | null = null;
  receiverCoordinates: { lat: number; lng: number } | null = null;

  constructor(
    private fb: FormBuilder,
    private translate: TranslateService,
    public settingService: SettingsService,
    private orderService: CustomerService,
    private toastr: ToastrService,
    private router: Router,
    private lookupsService: LookupsService,
    private ngZone: NgZone
  ) {
    this.current_lang = this.translate.currentLang;
    this.isApple = /iPad|iPhone|iPod/.test(navigator.userAgent);
    this.initForm();
  }

  ngOnInit() {
    this.onOrderCountChange();
    this.loadVehicleSizes();
    this.loadAdvancedMarkersLibrary();
  }
  countryCode = localStorage.getItem('countryCode');
  private loadAdvancedMarkersLibrary() {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMaps.apiKey}&libraries=places,marker&country=${this.countryCode}`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      this.geocoder = new google.maps.Geocoder();
    };
    document.head.appendChild(script);
  }

  loadVehicleSizes() {
    this.lookupsService.getDeliveryCarSizes().subscribe(
      (response: ResponseResult) => {
        if (response.isSuccess) {
          this.vehicleSizes = response.data;
        }
      },
      error => {
        console.error('Error loading vehicle sizes:', error);
      }
    );
  }

  initForm() {
    this.batchOrderForm = this.fb.group({
      deliveryServiceType: [1],
      senderName: ['', Validators.required],
      senderPhone: ['', [Validators.required, CustomValidators.phoneValidator]],
      senderAddress: ['', Validators.required],
      senderLatLng: ['', Validators.required],
      senderCity: ['', Validators.required],
      senderRegion: ['', Validators.required],
      senderStreet: [''],
      senderBuildingNo: [''],
      senderApartmentNo: [''],
      deliveryCarSizeId: ['', Validators.required],
      batchNotes: [''],
      orders: this.fb.array([])
    });
  }

  get orders() {
    return this.batchOrderForm.get('orders') as FormArray;
  }

  countryId = +localStorage.getItem('countryId');

  createOrderForm(): FormGroup {
    return this.fb.group({
      receiverName: ['', Validators.required],
      receiverPhone: ['', [Validators.required, CustomValidators.phoneValidator]],
      receiverAddress: ['', Validators.required],
      receiverLatLng: ['', Validators.required],
      receiverCity: ['', Validators.required],
      receiverRegion: ['', Validators.required],
      receiverStreet: [''],
      receiverBuildingNo: [''],
      receiverApartmentNo: [''],
      packageType: ['', Validators.required],
      packageDescription: [''],
      packageWeight: [''],
      price: [0],
      distance: [0],
      notes: [''],
      isActive: [true],
      packageImages: [[]]
    });
  }

  getCountryId(id: string) {
    localStorage.setItem('countryId', id);
    this.countryId = +id;
  }

  onOrderCountChange() {
    const currentLength = this.orders.length;
    if (this.orderCount > currentLength) {
      for (let i = currentLength; i < this.orderCount; i++) {
        this.orders.push(this.createOrderForm());
      }
    } else if (this.orderCount < currentLength) {
      for (let i = currentLength - 1; i >= this.orderCount; i--) {
        this.orders.removeAt(i);
        delete this.selectedImages[i];
      }
    }
  }

  setServiceType(type: 'send' | 'receive') {
    this.serviceType = type;
    this.batchOrderForm.patchValue({ deliveryServiceType: type === 'send' ? 1 : 2 });
  }

  toggleOrderTab(index: number) {
    const order = this.orders.at(index);
    order.patchValue({ isActive: !order.get('isActive').value });
  }

  selectVehicleSize(sizeId: number) {
    this.batchOrderForm.patchValue({ deliveryCarSizeId: sizeId });
    this.calculateBatchSendReceivePrices();

  }
  deliveryPrice: number = 0;
  calculateBatchSendReceivePrices() {
    // const object = {
    //   senderLatLng: this.batchOrderForm.get('senderLatLng').value,
    //   receiverLatLng: this.batchOrderForm.get('receiverLatLng').value,
    //   carSizeId: this.batchOrderForm.get('deliveryCarSizeId').value
    // };
    //iterate over the orders and get the senderLatLng and receiverLatLng
    let checkValidity = true;
    const object = [];
    this.orders.controls.forEach(order => {
      if(!order.get('receiverLatLng').value || !this.batchOrderForm.get('senderLatLng').value || !this.batchOrderForm.get('deliveryCarSizeId').value){
        checkValidity = false;
      }
      object.push({
        senderLatLng: this.batchOrderForm.get('senderLatLng').value,
        receiverLatLng: order.get('receiverLatLng').value,
        carSizeId: this.batchOrderForm.get('deliveryCarSizeId').value 
      });
    });
    if(!checkValidity){
      return;
    }
    this.orderService.calculateBatchSendReceivePrices(object).subscribe(
      (response: ResponseResult) => {
        console.log(response);
        if(response.isSuccess){
          this.deliveryPrice = response.data.totalPrice;
          this.orders.controls.forEach((order, index) => {
            order.patchValue({ price: response.data.orderResults[index].price, distance: response.data.orderResults[index].distance });
          });
        }
      }
    );
  }

  onFileSelected(event: any, orderIndex: number) {
    const files = event.target.files;
    if (files) {
      this.selectedImages[orderIndex] = this.selectedImages[orderIndex] || [];
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.selectedImages[orderIndex].push(e.target.result);
          this.orders.at(orderIndex).get('packageImages').value.push(files[i]);
        };
        reader.readAsDataURL(files[i]);
      }
    }
  }

  removeImage(orderIndex: number, imageIndex: number) {
    this.selectedImages[orderIndex].splice(imageIndex, 1);
    this.orders.at(orderIndex).get('packageImages').value.splice(imageIndex, 1);
  }

  getSelectedImages(orderIndex: number): string[] {
    return this.selectedImages[orderIndex] || [];
  }

  openMap(target: 'sender' | 'receiver', orderIndex?: number) {
    if (orderIndex !== undefined) {
      this.currentOrderIndex = orderIndex;
    }
    
    this.currentLocationTarget = target;
    if (this.mapContainer) {
      this.mapContainer.nativeElement.style.display = 'block';
    }

    setTimeout(() => {
      const mapOptions = {
        center: { lat: 29.3759, lng: 47.9774 }, // Kuwait City coordinates
        zoom: 12,
        mapId: environment.googleMaps.mapId
      };
      
      const mapElement = this.mapContainer.nativeElement.querySelector('.map-view');
      this.map = new google.maps.Map(mapElement, mapOptions);
      
      // Create the marker
      if (this.marker) {
        this.marker.setMap(null);
      }
      
      this.marker = new google.maps.marker.AdvancedMarkerElement({
        map: this.map,
        position: mapOptions.center,
        draggable: true,
        title: 'Drag me!'
      });

      // Add click event listener to map
      this.map.addListener('click', (event: any) => {
        this.updateMarkerPosition(event.latLng);
      });

      // Add dragend event listener to marker
      this.marker.addListener('dragend', () => {
        const position = this.marker.position;
        this.updateMarkerPosition(position);
      });

      // Initialize search box
      this.initializeSearchBox();
    });
  }

  private initializeSearchBox() {
    const searchInput = this.mapContainer.nativeElement.querySelector('.location-search-input');
    
    if (searchInput && google.maps.places) {
      this.searchBox = new google.maps.places.SearchBox(searchInput);
      
      // Bias SearchBox results towards current map's viewport
      this.map.addListener('bounds_changed', () => {
        this.searchBox.setBounds(this.map.getBounds());
      });

      // Listen for the event fired when the user selects a prediction
      this.searchBox.addListener('places_changed', () => {
        const places = this.searchBox.getPlaces();
        if (places.length === 0) return;

        const place = places[0];
        if (!place.geometry || !place.geometry.location) return;

        // Update map and marker
        this.map.setCenter(place.geometry.location);
        this.updateMarkerPosition(place.geometry.location);
      });
    }
  }

  searchLocation() {
    const searchValue = this.searchInput.nativeElement.value;
    
    if (!searchValue.trim()) return;

    this.geocoder.geocode({ address: searchValue }, (results: any, status: any) => {
      if (status === 'OK' && results[0]) {
        this.ngZone.run(() => {
          const location = results[0].geometry.location;
          
          // Update map and marker
          this.map.setCenter(location);
          if (this.marker) {
            this.marker.position = location;
          }
        });
      }
    });
  }

  closeMap() {
    if (this.mapContainer) {
      this.mapContainer.nativeElement.style.display = 'none';
    }
    if (this.marker) {
      this.marker.setMap(null);
    }
    this.map = null;
  }

  // confirmLocation() {
  //   if (!this.marker || !this.map) return;

  //   const position = this.marker.position;
  //   this.geocoder.geocode({ location: position }, (results: any, status: any) => {
  //     if (status === 'OK' && results[0]) {
  //       this.ngZone.run(() => {
  //         const addressComponents = results[0].address_components;
  //         const formattedAddress = results[0].formatted_address;
          
  //         // Create an object to store address components
  //         const addressParts: any = {
  //           street_number: '',
  //           route: '',
  //           locality: '',
  //           sublocality_level_1: '',
  //           administrative_area_level_1: '',
  //           country: ''
  //         };

  //         // Extract address components
  //         addressComponents.forEach((component: any) => {
  //           const type = component.types[0];
  //           if (addressParts.hasOwnProperty(type)) {
  //             addressParts[type] = component.long_name;
  //           }
  //         });
  //         console.log(addressParts);
  //         // Update form controls based on target
  //         if (this.currentLocationTarget === 'sender') {
  //           this.batchOrderForm.patchValue({
  //             senderAddress: formattedAddress,
  //             senderCity: addressParts.locality || '',
  //             senderRegion: addressParts.sublocality_level_1 || addressParts.administrative_area_level_1 || '',
  //             senderStreet: (addressParts.street_number ? addressParts.street_number + ' ' : '') + (addressParts.route || ''),
  //             senderLatLng: `${position.lat},${position.lng}`
  //           });
  //           this.senderCoordinates = {
  //             lat: position.lat,
  //             lng: position.lng
  //           };
  //         } else {
  //           const order = this.orders.at(this.currentOrderIndex);
  //           if (order) {
  //             order.patchValue({
  //               receiverAddress: formattedAddress,
  //               receiverCity: addressParts.locality || '',
  //               receiverRegion: addressParts.sublocality_level_1 || addressParts.administrative_area_level_1 || '',
  //               receiverStreet: (addressParts.street_number ? addressParts.street_number + ' ' : '') + (addressParts.route || ''),
  //               receiverLatLng: `${position.lat},${position.lng}`
  //             });
  //             this.receiverCoordinates = {
  //               lat: position.lat,
  //               lng: position.lng
  //             };
  //           }
  //         }

  //         this.closeMap();
  //         this.calculateBatchSendReceivePrices();
  //       });
  //     }
  //   });
  // }
  confirmLocation() {
    if (!this.marker || !this.map) return;
  
    const position = this.marker.position;
    this.geocoder.geocode({ location: position }, (results: any, status: any) => {
      if (status === 'OK' && results[0]) {
        this.ngZone.run(() => {
          const addressComponents = results[0].address_components;
          const formattedAddress = results[0].formatted_address;
          
          // Enhanced address parts extraction
          const addressParts = this.extractAddressParts(addressComponents);
          console.log('Extracted address parts:', addressParts);
  
          // Compose address components
          const addressValues = {
            city: addressParts.locality || addressParts.postal_town || addressParts.sublocality_level_1 || '',
            region: addressParts.administrative_area_level_1 || addressParts.sublocality_level_1 || '',
            street: [addressParts.street_number, addressParts.route].filter(Boolean).join(' '),
            latLng: `${position.lat},${position.lng}`
          };
  
          // Update form based on target
          if (this.currentLocationTarget === 'sender') {
            this.updateSenderLocation(formattedAddress, addressValues, position);
          } else {
            this.updateReceiverLocation(formattedAddress, addressValues, position);
          }
  
          this.closeMap();
          this.calculateBatchSendReceivePrices();
        });
      }
    });
  }
  
  // Helper method to extract address parts
  extractAddressParts(components: any[]): any {
    const addressParts: any = {
      street_number: '',
      route: '',
      locality: '',
      postal_town: '',
      sublocality_level_1: '',
      administrative_area_level_1: '',
      country: ''
    };
  
    components.forEach((component: any) => {
      component.types.forEach((type: string) => {
        if (addressParts.hasOwnProperty(type)) {
          addressParts[type] = component.long_name;
        }
      });
    });
  
    return addressParts;
  }
  
  // Helper method to update sender location
  updateSenderLocation(address: string, values: any, position: any) {
    this.batchOrderForm.patchValue({
      senderAddress: address,
      senderCity: values.city,
      senderRegion: values.region,
      senderStreet: values.street,
      senderLatLng: values.latLng
    });
    this.senderCoordinates = {
      lat: position.lat,
      lng: position.lng
    };
  }
  
  // Helper method to update receiver location
  updateReceiverLocation(address: string, values: any, position: any) {
    const order = this.orders.at(this.currentOrderIndex);
    if (order) {
      order.patchValue({
        receiverAddress: address,
        receiverCity: values.city,
        receiverRegion: values.region,
        receiverStreet: values.street,
        receiverLatLng: values.latLng
      });
      this.receiverCoordinates = {
        lat: position.lat,
        lng: position.lng
      };
    }
  }

  updateMarkerPosition(position: any) {
    if (this.marker) {
      this.marker.position = position;
    }
  }

  getPaymentMethodKeys(): string[] {
    return Object.keys(this.paymentMethodIcons);
  }

  toggleModal(value: number, text: string) {
    this.paymentNumber = value;
    this.paymentMethodText = text;
  }

  closeModal() {
    $('#paymentMethodsModal').modal('hide');
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.batchOrderForm.get(fieldName);
    return field.invalid && (field.dirty || field.touched);
  }

  isFieldOrderInvalid(fieldName: string, orderIndex: number): boolean {
    const order = this.orders.at(orderIndex);
    if (!order) return false;

    const control = order.get(fieldName);
    return control && control.invalid && (control.dirty || control.touched);
  }

  getErrorMessage(fieldName: string): string {
    const control = this.batchOrderForm.get(fieldName);
    if (!control) return '';

    if (control.hasError('required')) {
      return 'ThisFieldRequired';
    }

    if (control.hasError('invalidPhoneNumber')) {
      return 'PhoneNumberNotValid';
    }

    return '';
  }

  onSubmit() {
    if (this.batchOrderForm.valid) {
      this.isSubmitting = true;
      const formData = this.prepareFormData();

      this.orderService.createBatchOrder(formData).subscribe(
        (response) => {
          this.toastr.success(this.translate.instant('BatchOrderCreatedSuccessfully'));
          this.router.navigate(['/my-orders']);
        },
        (error) => {
          this.toastr.error(this.translate.instant('ErrorCreatingBatchOrder'));
          this.isSubmitting = false;
        }
      );
    } else {
      this.markFormGroupTouched(this.batchOrderForm);
    }
  }

  private prepareFormData() {
    const formValue = this.batchOrderForm.value;
    const orders = formValue.orders.map((order, index) => ({
      ...order,
      deliveryServiceType: this.serviceType === 'send' ? 1 : 2,
      paymentTypeId: this.paymentNumber,
      senderName: formValue.senderName,
      senderPhone: formValue.senderPhone,
      senderAddress: formValue.senderAddress,
      senderLatLng: formValue.senderLatLng,
      senderCity: formValue.senderCity,
      senderRegion: formValue.senderRegion,
      senderStreet: formValue.senderStreet,
      senderBuildingNo: formValue.senderBuildingNo,
      senderApartmentNo: formValue.senderApartmentNo,
      deliveryCarSizeId: formValue.deliveryCarSizeId,
      price: this.orders.at(index).get('price').value,
      distance: this.orders.at(index).get('distance').value
    }));

    return {
      orders,
      batchNotes: formValue.batchNotes
    };
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  isOrderValid(orderIndex: number): boolean {
    const order = this.orders.at(orderIndex);
    if (!order) return false;

    // Required fields for each order
    const requiredFields = [
      'receiverName',
      'receiverPhone',
      'receiverAddress',
      'receiverCity',
      'receiverRegion',
      'receiverStreet',
      'receiverBuildingNo',
      'packageType',
      'packageDescription',
      'packageWeight'
    ];

    // Check if all required fields are valid
    return requiredFields.every(field => {
      const control = order.get(field);
      return control && control.valid && !control.errors;
    });
  }

  navigateOrder(index: number) {
    if (index >= 0 && index < this.orders.length) {
      // Deactivate all orders
      this.orders.controls.forEach(control => {
        control.patchValue({ isActive: false });
      });
      // Activate the target order
      this.orders.at(index).patchValue({ isActive: true });
    }
  }

  getCurrentOrderIndex(): number {
    return this.orders.controls.findIndex(control => control.get('isActive').value);
  }

  isFirstOrder(): boolean {
    return this.getCurrentOrderIndex() === 0;
  }

  isLastOrder(): boolean {
    return this.getCurrentOrderIndex() === this.orders.length - 1;
  }

  // fillCurrentLocation(type: 'sender' | 'receiver', orderIndex?: number) {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition((position) => {
  //       const pos = {
  //         lat: position.coords.latitude,
  //         lng: position.coords.longitude
  //       };

  //       const geocoder = new google.maps.Geocoder();
  //       geocoder.geocode({ location: pos }, (results: any, status: any) => {
  //         if (status === 'OK' && results[0]) {
  //           const addressComponents = results[0].address_components;
  //           const formattedAddress = results[0].formatted_address;
            
  //           // Create an object to store address components
  //           const addressParts: any = {
  //             street_number: '',
  //             route: '',
  //             locality: '',
  //             sublocality_level_1: '',
  //             administrative_area_level_1: '',
  //             country: ''
  //           };

  //           // Extract address components
  //           addressComponents.forEach((component: any) => {
  //             const type = component.types[0];
  //             if (addressParts.hasOwnProperty(type)) {
  //               addressParts[type] = component.long_name;
  //             }
  //           });

  //           if (type === 'sender') {
  //             this.batchOrderForm.patchValue({
  //               senderAddress: formattedAddress,
  //               senderCity: addressParts.locality || '',
  //               senderRegion: addressParts.sublocality_level_1 || addressParts.administrative_area_level_1 || '',
  //               senderStreet: (addressParts.street_number ? addressParts.street_number + ' ' : '') + (addressParts.route || ''),
  //               senderLatLng: `${pos.lat},${pos.lng}`
  //             });
  //             this.senderCoordinates = pos;
  //           } else if (orderIndex !== undefined) {
  //             const order = this.orders.at(orderIndex);
  //             if (order) {
  //               order.patchValue({
  //                 receiverAddress: formattedAddress,
  //                 receiverCity: addressParts.locality || '',
  //                 receiverRegion: addressParts.sublocality_level_1 || addressParts.administrative_area_level_1 || '',
  //                 receiverStreet: (addressParts.street_number ? addressParts.street_number + ' ' : '') + (addressParts.route || ''),
  //                 receiverLatLng: `${pos.lat},${pos.lng}`
  //               });
  //               this.receiverCoordinates = pos;
  //             }
  //           }

  //           this.calculateBatchSendReceivePrices();
  //         }
  //       });
  //     });
  //   }
  // }
  // Store the last known position to avoid fluctuations
private lastKnownPosition: { lat: number; lng: number } | null = null;

fillCurrentLocation(type: 'sender' | 'receiver', orderIndex?: number, retryCount = 0) {
  if (!navigator.geolocation) {
    console.error("Geolocation is not supported.");
    return;
  }

  const geolocationOptions = {
    enableHighAccuracy: true, // Prefer GPS over IP-based location
    maximumAge: 0,           // Do not use a cached position
    timeout: 10000           // Wait up to 10 seconds
  };

  navigator.geolocation.getCurrentPosition(
    (position) => {
      // Check if the location is accurate enough (e.g., within 50 meters)
      if (position.coords.accuracy > 50) {
        console.warn("Low accuracy detected:", position.coords.accuracy, "meters");
        if (retryCount < 2) { // Retry up to 2 times
          this.fillCurrentLocation(type, orderIndex, retryCount + 1);
          return;
        }
      }

      const newPos = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };

      // If we have a previous position, check if the new one is significantly different
      if (this.lastKnownPosition) {
        const distance = this.calculateDistance(
          this.lastKnownPosition.lat,
          this.lastKnownPosition.lng,
          newPos.lat,
          newPos.lng
        );

        // If the new position is < 10m away from the last one, reuse the last known position
        if (distance < 10) {
          newPos.lat = this.lastKnownPosition.lat;
          newPos.lng = this.lastKnownPosition.lng;
        }
      }

      this.lastKnownPosition = newPos; // Cache the position
      this.geocodePosition(newPos, type, orderIndex);
    },
    (error) => {
      console.error("Geolocation error:", error.message);
      if (error.code === error.TIMEOUT && retryCount < 2) {
        this.fillCurrentLocation(type, orderIndex, retryCount + 1); // Retry on timeout
      }
    },
    geolocationOptions
  );
}

// Helper: Calculate distance between two coordinates (in meters)
private calculateDistance(lat1: number, lng1: number, lat2: number, lng2: number) {
  const R = 6371e3; // Earth radius in meters
  const φ1 = lat1 * Math.PI / 180;
  const φ2 = lat2 * Math.PI / 180;
  const Δφ = (lat2 - lat1) * Math.PI / 180;
  const Δλ = (lng2 - lng1) * Math.PI / 180;

  const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
            Math.cos(φ1) * Math.cos(φ2) *
            Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
}

private geocodePosition(pos: { lat: number; lng: number }, type: 'sender' | 'receiver', orderIndex?: number) {
  const geocoder = new google.maps.Geocoder();
  geocoder.geocode({ location: pos }, (results, status) => {
    if (status !== "OK" || !results?.[0]) {
      console.error("Geocoding failed:", status);
      return;
    }

    const formattedAddress = results[0].formatted_address;
    const addressParts = this.extractAddressComponents(results[0].address_components);

    if (type === "sender") {
      this.updateSenderAddress(formattedAddress, addressParts, pos);
    } else if (orderIndex !== undefined) {
      this.updateReceiverAddress(orderIndex, formattedAddress, addressParts, pos);
    }

    this.calculateBatchSendReceivePrices();
  });
}


  private extractAddressComponents(components: google.maps.GeocoderAddressComponent[]) {
    const addressParts: Record<string, string> = {};

    components.forEach((component) => {
      component.types.forEach((type) => {
        addressParts[type] = component.long_name;
      });
    });

    return {
      street: [addressParts['street_number'], addressParts['route']].filter(Boolean).join(' '),
      city: addressParts['locality'] || addressParts['sublocality_level_1'] || '',
      region: addressParts['administrative_area_level_1'] || '',
      country: addressParts['country'] || ''
    };
  }

  private updateSenderAddress(address: string, parts: ReturnType<typeof this.extractAddressComponents>, pos: { lat: number; lng: number }) {
    this.batchOrderForm.patchValue({
      senderAddress: address,
      senderCity: parts.city,
      senderRegion: parts.region,
      senderStreet: parts.street,
      senderLatLng: `${pos.lat},${pos.lng}`
    });
    this.senderCoordinates = pos;
  }

  private updateReceiverAddress(index: number, address: string, parts: ReturnType<typeof this.extractAddressComponents>, pos: { lat: number; lng: number }) {
    const order = this.orders.at(index);
    if (!order) return;

    order.patchValue({
      receiverAddress: address,
      receiverCity: parts.city,
      receiverRegion: parts.region,
      receiverStreet: parts.street,
      receiverLatLng: `${pos.lat},${pos.lng}`
    });
    this.receiverCoordinates = pos;
  }
}
